import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper, Btn } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";
import { IoCopySharp } from "react-icons/io5";
import moment from "moment";
import { capitalizeFirstLetter, handleCopy } from "../../helpers";
import { FiChevronRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { MdDelete, MdModeEditOutline } from "react-icons/md";
import Tooltip from "../Tooltip";
import { toast } from "react-toastify";

const Table = ({
  apiData,
  setSelectedData,
  setShowEditBroker,
  setDeleteBroker,
  getInventoryListMutate,
}) => {
  const storageKey = `landlord_list_page`;
  const navigate = useNavigate();
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [openActionMenu, setOpenActionMenu] = useState(null);

  // Load saved page index
  const storageValue = sessionStorage.getItem(storageKey);
  const savedPage = storageValue !== null ? Number(storageValue) : 0;
  const [currentPage, setCurrentPage] = useState(savedPage);
  useEffect(() => {
    setCurrentPage(savedPage);
  }, [savedPage]);

  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const goToSummary = (item) => {
    navigate(`/landlord/details`, {
      state: {
        landlordId: item.id,
      },
    });
  };

  const ActionBtns = (item) => {
    const isDeleteAllowed = !item.inventoryCount || item.inventoryCount === 0;
    return (
      <div className="flex items-center gap-3">
        <Tooltip label="Click to edit the broker">
          <button
            onClick={() => edit(item)}
            className="text-gray-400 hover:text-gray-700 transition bg-gray-50 rounded-full p-1.5"
            // title="Edit Location"
          >
            <MdModeEditOutline size={16} />
          </button>
        </Tooltip>
        <Tooltip
          label={
            isDeleteAllowed
              ? "Click to delete the broker"
              : "Cannot delete broker with active inventory"
          }
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
              deleteBroker(item);
            }}
            className={`rounded-full p-1.5 transition
                            ${
                              isDeleteAllowed
                                ? "text-gray-400 hover:text-rose-600 bg-gray-50"
                                : "text-gray-300 bg-gray-100 cursor-not-allowed"
                            }`}
          >
            <MdDelete size={16} />
          </button>
        </Tooltip>
      </div>
    );
  };

  const edit = (item) => {
    setSelectedData(item);
    setShowEditBroker(true);
  };

  const showProps = (item) => {
    setSelectedData(item);
    // setShowViewProps(true);
    getInventoryListMutate(item);
    // setOpenActionMenu(null);
  };

  const deleteBroker = (item) => {
    if (item.inventoryCount && item.inventoryCount > 0) {
      toast.error("Inventory count is present");
      return;
    }
    setSelectedData(item);
    setDeleteBroker(item);
  };

  const getInventories = (item) => {
    // If no inventories show only number, no arrow, no click
    if (!item.inventoryCount || item.inventoryCount === 0) {
      return (
        <span className="px-3 py-1.5 bg-gray-100 text-sm font-medium text-gray-400 rounded-full inline-flex">
          None
        </span>
      );
    }

    // If inventories exist show clickable button with arrow
    return (
      <div className="flex items-center gap-2">
        <button
          onClick={() => showProps(item)}
          className="px-3 py-1.5 bg-neutral-100 hover:bg-neutral-200 text-sm font-medium text-gray-700 flex items-center gap-2 rounded-full transition"
        >
          {item.inventoryCount}
          <FiChevronRight size={14} />
        </button>
      </div>
    );
  };

  useEffect(() => {
    if (Array.isArray(apiData)) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        mobile: "#" + item?.mobile,
        agreementDuration: agreementDuration(item),
        dues: getDuesAmount(item),
        inventories: getInventories(item),
        rent: <Payment>₹{item?.lifetimePayment || 0}</Payment>,
        status: getStatus(item.status),

        createdAt: moment(item.createdAt).format("DD, MMM YY"),
        action: ActionBtns(item),
      }));

      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  const getStatus = (status) => {
    if (status === 1) {
      return (
        <span className="text-xs text-green-600 bg-green-50 px-3 py-1 rounded-full">
          Active
        </span>
      );
      // } else if (status === 2) {
      //   return <span>Completed</span>;
      // } else if (status === 3) {
      //   return <span>Active</span>;
      // } else if (status === 4) {
      //   return <span>Inactive</span>;
      // } else if (status === 5) {
      //   return <span>Deleted</span>;
    } else {
      return (
        <span className="text-xs text-red-600 bg-red-50 px-3 py-1 rounded-full">
          Inactive
        </span>
      );
    }
  };
  const getDuesAmount = (item) => {
    const total = (item.inventories || []).reduce(
      (sum, d) => sum + Number(d.pendingDues || 0),
      0,
    );

    if (!total) {
      return (
        <span className="text-xs text-green-600 bg-green-50 px-3 py-1 rounded-full">
          No dues
        </span>
      );
    }

    return <Amount onClick={() => goToSummary(item)}>₹{total}</Amount>;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const agreementDuration = (item) => {
    return (
      <div className="flex gap-3 ">
        <div className="flex flex-col text-sm text-gray-600">
          <span>
            {item.startDate ? moment(item.startDate).format("DD-MMM-YY") : "-"}
            {" - "}
            {item.endDate ? moment(item.endDate).format("DD-MMM-YY") : "-"}
          </span>
        </div>
      </div>
    );
  };

//   const getName = (item) => {
//     const name = capitalizeFirstLetter(item?.name || "N/A");

//     return (
//       <UserImageWrapper>
//         <UserImage src={Images.Avatar} alt={name} />

//         <div className="flex flex-col min-w-0">
//           <span className="text-sm font-medium text-gray-900 truncate max-w-[180px]">
//             {name}
//           </span>

//           <div className="flex items-center gap-1 text-xs text-gray-400">
//             <span>#{item.mobile}</span>
//             <button
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleCopy(item.mobile);
//               }}
//               className="hover:text-gray-600 transition"
//               title="Copy number"
//             >
//               <IoCopySharp size={12} />
//             </button>
//           </div>
//         </div>
//       </UserImageWrapper>
//     );
//   };
const getName = (item) => {
  const name = capitalizeFirstLetter(item?.name || "N/A");

  const fields = [
    item?.firmName && (
      <span><strong>Firm:</strong> {item.firmName}</span>
    ),
    item?.email && (
      <span><strong>Email:</strong> {item.email}</span>
    ),
    item?.reraNum && (
      <span><strong>RERA:</strong> {item.reraNum}</span>
    ),
    item?.address && (
      <span><strong>Address:</strong> {item.address}</span>
    ),
  ].filter(Boolean); // remove nulls

  const content = (
    <UserImageWrapper>
      <UserImage src={Images.Avatar} alt={name} />

      <div className="flex flex-col min-w-0">
        <span className="text-sm font-medium text-gray-900 truncate max-w-[180px]">
          {name}
        </span>

        <div className="flex items-center gap-1 text-xs text-gray-400">
          <span>#{item.mobile}</span>
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleCopy(item.mobile);
            }}
            className="hover:text-gray-600 transition"
            title="Copy number"
          >
            <IoCopySharp size={12} />
          </button>
        </div>
      </div>
    </UserImageWrapper>
  );

  if (fields.length === 0) {
    return content;
  }

  return (
    <Tooltip
      label={
        <div className="flex flex-col text-xs text-left gap-0.5">
          {fields}
        </div>
      }
    >
      {content}
    </Tooltip>
  );
};

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Name",
          accessor: "name",
        },
        {
          Header: "Inventories",
          accessor: "inventories",
        },
      ];
    }
    return [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Inventories",
        accessor: "inventories",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Created At",
        accessor: "createdAt",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    //setCurrentPage(pageIndex);
    sessionStorage.setItem(storageKey, pageIndex);
  }, [pageIndex, storageKey]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          hasdata={(apiData?.length > 0).toString()}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            const rowData = apiData[rowIndex];
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps({ style: { height: "80px" } })}
                  hasdata={(apiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Rent</strong> {data[rowIndex].rent}
                        </li>
                        <li>
                          <strong>Rent Date</strong> {data[rowIndex].rentDate}
                        </li>
                        <li>
                          <strong>Agreement Duration</strong>{" "}
                          {data[rowIndex].agreementDuration}
                        </li>
                        <li>
                          <strong>Action</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const CustomTable = tw.table` w-full text-gray-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2`;
const UserImage = tw.img`w-10 h-10 rounded-full `;
//const Amount = tw.p`text-gray-600 text-sm bg-rose-100 px-3 py-1 rounded-md inline-flex cursor-pointer`;
const Amount = tw.p`
  text-rose-700
  bg-rose-50
  text-sm
  font-semibold
  px-3 py-1
  rounded-full
  inline-flex
  cursor-pointer
`;

const Payment = tw.span`
  bg-neutral-100
  text-gray-800
  px-3 py-1
  rounded-full
  text-sm
  font-medium
  inline-flex
`;

export default Table;
